import { render, staticRenderFns } from "./Commercial.vue?vue&type=template&id=31b5d46d&scoped=true&lang=pug"
import script from "./Commercial.vue?vue&type=script&lang=js"
export * from "./Commercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b5d46d",
  null
  
)

export default component.exports